/* ==========================================================================
   si6teen — cart-page-fix.js
   Fixes the cart page's Remove button and quantity stepper, which the main
   theme.js only wires up inside the cart drawer (not the /cart page).
   Self-contained: does not depend on theme.js internals.
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.ECCO_ROUTES || {
    cart_change_url: '/cart/change',
    root_url: '/'
  };

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json();
    });
  }

  function refreshCartPage() {
    var cartPageRoot = document.querySelector('[data-cart-page]');
    if (!cartPageRoot) return Promise.resolve();

    var url = routes.root_url.replace(/\/$/, '') + '/?sections=main-cart';

    return fetchJSON(url).then(function (data) {
      if (data['main-cart']) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['main-cart'];
        var fresh = tmp.querySelector('[data-cart-page]');
        if (fresh) {
          cartPageRoot.innerHTML = fresh.innerHTML;
        }
      }
    });
  }

  function refreshHeaderCart() {
    if (typeof window.si6teenRefreshCartSections === 'function') {
      return window.si6teenRefreshCartSections();
    }
    return Promise.resolve();
  }

  function changeLine(line, quantity, triggerBtn) {
    return fetchJSON(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () {
      return Promise.all([refreshCartPage(), refreshHeaderCart()]);
    }).catch(function (err) {
      console.error('si6teen cart page update failed:', err);
      if (triggerBtn) {
        triggerBtn.classList.remove('is-loading');
        triggerBtn.disabled = false;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-page] [data-remove-line]');
    if (!btn) return;

    e.preventDefault();

    if (btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    changeLine(btn.getAttribute('data-remove-line'), 0, btn);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-page] [data-cart-line-qty]');
    if (!input) return;

    var qty = parseInt(input.value, 10);
    if (!Number.isFinite(qty) || qty < 1) {
      qty = 1;
    }

    changeLine(input.getAttribute('data-cart-line-qty'), qty);
  });
})();
